<div class="mb-4" *ngIf="loadingCompleted">
    <app-basic-card>
        <div class="d-flex justify-content-start align-items-center mb-2">
            <h4 class="m-0">{{operationTitle}}</h4>
            <mat-icon class="info-icon" aria-hidden="false" fontIcon="info_outline" (click)="openConstraintsModal()" *ngIf="showConstraintsInfoMessage"></mat-icon>
            <mat-icon class="alert-icon" aria-hidden="false" fontIcon="warning_amber" (click)="openOperationErrorModal()" *ngIf="operationHasError"></mat-icon>
        </div>
        <ng-container *ngIf="canViewStepper; else errorBlock">
            <mat-stepper #stepper [linear]="true" [selectedIndex]="selectedIndex" *ngIf="loadingCompleted">
                <!-- VARIAZIONE NDG MIFID -->
                <ng-container *ngIf="customerHasTutor && ndgVariationForm">
                    <mat-step [stepControl]="ndgVariationForm.valid">
                        <ng-template matStepLabel>Selezione del soggetto richiedente</ng-template>
                        <ng-template matStepContent>
                            <div class="step-item-box">
                                <app-ndg-variation [form]="ndgVariationForm" [ndgVariationList]="ndgVariationList"
                                    [selectedSubject]="searchedSubject"
                                    (onSubjectSelection)="onSubjectSelection($event)">
                                </app-ndg-variation>
                            </div>
                            <div class="d-flex justify-content-end">
                                <button mat-raised-button color="primary" (click)="next('NDG_VARIATION')"
                                    [disabled]="!ndgVariationForm.valid && !ndgVariationForm.disabled">Avanti</button>
                            </div>
                        </ng-template>
                    </mat-step>
                </ng-container>
                <!-- INSERIMENTO OPERAZIONE -->
                <ng-container *ngIf="isSingleStepOperation; else multiStepOperationBlock">
                    <mat-step [stepControl]="isStepValid(operationId)" [editable]="isFirstStepActive">
                        <ng-template matStepLabel>Inserimento operazione</ng-template>
                        <ng-template matStepContent>
                            <div class="step-item-box">
                                <ng-container [ngSwitch]="operationId">
                                    <ng-container *ngSwitchCase="'_VAGG'">
                                        <app-additional-payment [form]="firstStepForm"
                                            [ibanList]="ibanList" [assets]="policyAssets"
                                            [isReadOnly]="isWriteDisabled">
                                        </app-additional-payment>
                                    </ng-container>
                                    <ng-container *ngSwitchCase="'_RISPA'">
                                        <app-partial-redeem [form]="firstStepForm"
                                          [ibanList]="ibanList"
                                          [assets]="policyAssets"
                                          [funds]="funds"
                                          [isReadOnly]="isWriteDisabled"
                                          (emitFunds)="emittedFunds($event)">
                                        </app-partial-redeem>
                                    </ng-container>
                                    <ng-container *ngSwitchCase="'_RISTO'">
                                        <app-total-redeem [form]="firstStepForm" [ibanList]="ibanList">
                                        </app-total-redeem>
                                    </ng-container>
                                    <ng-container *ngSwitchCase="'_INPAG'">
                                        <app-premium-payment-suspension [form]="firstStepForm">
                                        </app-premium-payment-suspension>
                                    </ng-container>
                                    <ng-container *ngSwitchCase="'_RIAPU'">
                                        <app-premium-payment-reactivation [form]="firstStepForm">
                                        </app-premium-payment-reactivation>
                                    </ng-container>
                                    <ng-container *ngSwitchCase="'_VBENE'">
                                        <app-beneficiary-change [beneficiariesList]="beneficiariesList"
                                            [isReadOnly]="isWriteDisabled">
                                        </app-beneficiary-change>
                                    </ng-container>
                                    <ng-container *ngSwitchCase="'_VCBMU'">
                                        <app-bank-account-update [form]="firstStepForm" [ibanList]="ibanList"
                                            [currentBankAccount]="currentBankAccount">
                                        </app-bank-account-update>
                                    </ng-container>
                                    <ng-container *ngSwitchCase="'_SCOPZ'">
                                        <app-liquidation-maturity [form]="firstStepForm" [ibanList]="ibanList">
                                        </app-liquidation-maturity>
                                    </ng-container>
                                    <ng-container *ngSwitchCase="'_VBESC'">
                                        <app-liquidation-maturity [form]="firstStepForm" [ibanList]="ibanList">
                                        </app-liquidation-maturity>
                                    </ng-container>
                                    <ng-container *ngSwitchCase="'_VPRFR'">
                                        <app-frequency-premium-change [form]="firstStepForm"
                                            [frequenciesList]="frequencies">
                                        </app-frequency-premium-change>
                                    </ng-container>
                                    <ng-container *ngSwitchCase="'_SWIT'">
                                        <app-single-step-branch-switch [form]="firstStepForm" [assets]="policyAssets">
                                        </app-single-step-branch-switch>
                                    </ng-container>
                                    <ng-container *ngSwitchCase="'_ARIST'">
                                        <app-cancel-operation>
                                        </app-cancel-operation>
                                    </ng-container>
                                    <ng-container *ngSwitchCase="'_ARISP'">
                                        <app-cancel-operation>
                                        </app-cancel-operation>
                                    </ng-container>
                                    <ng-container *ngSwitchCase="'_ANAPP'">
                                        <app-cancel-operation>
                                        </app-cancel-operation>
                                    </ng-container>
                                    <ng-container *ngSwitchCase="'_VCONT'">
                                        <app-contractor-variation [form]="firstStepForm" [subjectForm]="searchForm" [addressForm]="contractorAddressForm"
                                            [ibanList]="ibanList" [searchedSubject]="searchedSubject"
                                            [isReadOnly]="isWriteDisabled" [countriesList]="countriesList"
                                            [provincesList]="provincesList" [citiesList]="citiesList"
                                            (onContractorSearch)="onContractorSearch($event)"
                                            (onContractorReset)="onContractorReset()">
                                        </app-contractor-variation>
                                    </ng-container>
                                    <ng-container *ngSwitchCase="'_VRECP'">
                                        <app-address-change [form]="firstStepForm" [isReadOnly]="isWriteDisabled"
                                            [countriesList]="countriesList" [provincesList]="provincesList"
                                            [citiesList]="citiesList">
                                        </app-address-change>
                                    </ng-container>
                                    <ng-container *ngSwitchCase="'_SIMOR'">
                                        <app-claim-notification [form]="firstStepForm"
                                            [beneficiariesList]="beneficiariesList" [isReadOnly]="isWriteDisabled"
                                            [questionnaireForm]="questionnaireForm"
                                            [questionnaires]="retrievedQuestionnaires" [questionnairesArray]="questionnairesArray"
                                            [newLiquidationSubjects]="newLiquidationSubjects"
                                            (viewSubject)="onViewSubject($event)" (deleteSubject)="onDeleteSubject($event)"
                                            (newLiquidationSubjectsChange)="onLiquidationSubjectsChange($event)"
                                          >
                                        </app-claim-notification>
                                    </ng-container>
                                </ng-container>
                            </div>
                            <ng-container *ngIf="canChangeNDG; else defaultButtonList">
                                <div class="d-flex justify-content-between">
                                    <button mat-raised-button color="accent" (click)="previous()">Indietro</button>
                                    <button mat-raised-button color="primary" (click)="next('FIRST_STEP')"
                                        [disabled]="!isStepValid(operationId, 'FIRST_STEP')">Avanti</button>
                                </div>
                            </ng-container>
                            <ng-template #defaultButtonList>
                                <div class="d-flex justify-content-end">
                                    <button mat-raised-button color="primary" (click)="next('FIRST_STEP')"
                                        [disabled]="!isStepValid(operationId, 'FIRST_STEP')">Avanti</button>
                                </div>
                            </ng-template>
                        </ng-template>
                    </mat-step>
                </ng-container>
                <ng-template #multiStepOperationBlock>
                    <ng-container [ngSwitch]="operationId">
                        <ng-container *ngSwitchCase="'_SWIT'">
                            <mat-step>
                                <ng-template matStepLabel>Disinvestimento</ng-template>
                                <ng-template matStepContent>
                                    <div class="step-item-box">
                                        <app-branch-switch-divestment
                                            [form]="firstStepForm"
                                            [policyFunds]="funds"
                                            [isReadOnly]="isWriteDisabled"
                                            (emitFunds)="emittedFunds($event)"
                                        ></app-branch-switch-divestment>
                                    </div>
                                    <div class="d-flex justify-content-end">
                                        <button
                                            mat-raised-button
                                            color="primary"
                                            (click)="next('FIRST_STEP')"
                                            [disabled]="!isStepValid(operationId)"
                                        >Avanti</button>
                                    </div>
                                </ng-template>
                            </mat-step>
                            <mat-step>
                                <ng-template matStepLabel>Investimento</ng-template>
                                <ng-template matStepContent>
                                    <div class="step-item-box">
                                        <app-branch-switch-investment
                                            [assets]="policyAssets"
                                            [policyFunds]="funds"
                                            [form]="secondStepForm"
                                            [isReadOnly]="isWriteDisabled"
                                        ></app-branch-switch-investment>
                                    </div>
                                    <div class="d-flex justify-content-between">
                                        <button
                                            mat-raised-button
                                            color="accent"
                                            (click)="previous()"
                                        >Indietro</button>
                                        <button
                                            mat-raised-button
                                            color="primary"
                                            (click)="next('ADDITIONAL_STEP')"
                                            [disabled]="!isStepValid(operationId, 'ADDITIONAL_STEP')"
                                        >Avanti</button>
                                    </div>
                                </ng-template>
                            </mat-step>
                        </ng-container>
                    </ng-container>
                </ng-template>
                <!-- QUESTIONARI -->
                <ng-container *ngIf="questionnaireIsPresent">
                    <mat-step [stepControl]="isQuestionnaireFormValid">
                        <ng-template matStepLabel>Adempimento questionari</ng-template>
                        <ng-template matStepContent>
                            <div class="step-item-box">
                                <app-questionnaire [form]="questionnaireForm" [formKeys]="questionnaireFormKeys"
                                    [questionnaire]="questionnaire" [newLiquidationSubjects]="newLiquidationSubjects" (viewSubject)="onViewSubject($event)" (deleteSubject)="onDeleteSubject($event)" (newLiquidationSubjectsChange)="newLiquidationSubjects = $event">
                                </app-questionnaire>
                            </div>
                            <div class="d-flex justify-content-between">
                                <button mat-raised-button color="accent" (click)="previous()">Indietro</button>
                                <button mat-raised-button color="primary" (click)="next('QUESTIONNAIRE')"
                                    [disabled]="confirmOperationDisabled">Avanti</button>
                            </div>
                        </ng-template>
                    </mat-step>
                </ng-container>
                <!-- DOWNLOAD DOCUMENTAZIONE -->
                <mat-step>
                    <ng-template matStepLabel>Download documentazione</ng-template>
                    <ng-template matStepContent>
                        <div class="step-item-box">
                            <app-document-download
                                [documents]="documentsList" [errorRetrievingDocs]="errorRetrievingDocs" [isAlreadySubmitted]="isAlreadySubmitted"></app-document-download>
                        </div>
                        <div class="d-flex justify-content-between">
                            <button mat-raised-button color="accent" (click)="previous()"
                                [disabled]="hasNoFirstStep">Indietro</button>
                            <button *ngIf="!isCancelOperation" mat-raised-button color="primary" (click)="next('DOWNLOAD_DOC')"
                                [disabled]="hasDocsToDownload || errorRetrievingDocs">Avanti</button>
                            <button *ngIf="isCancelOperation" mat-raised-button color="primary" (click)="next('NAVIGATE_POLICY')"
                                [disabled]="hasDocsToDownload">Torna alla polizza</button>
                        </div>
                    </ng-template>
                </mat-step>
                <!-- UPLOAD DOCUMENTAZIONE -->
                <mat-step *ngIf="!isCancelOperation">
                    <ng-template matStepLabel>Caricamento documentazione</ng-template>
                    <ng-template matStepContent>
                        <div class="step-item-box">
                            <app-document-upload [documents]="documentsList" [isAlreadySubmitted]="isAlreadySubmitted" [isHelpDeskAccount]="isHelpDeskAccount"></app-document-upload>
                        </div>
                        <div class="d-flex justify-content-between">
                            <button mat-raised-button color="accent" (click)="previous()">Indietro</button>
                            <button mat-raised-button color="primary" (click)="next('UPLOAD_DOC')"
                                [disabled]="hasDocsToUpload"
                                *ngIf="!isAlreadySubmitted && !isHelpDeskAccount">Conferma</button>
                        </div>
                    </ng-template>
                </mat-step>
            </mat-stepper>
        </ng-container>
        <ng-template #errorBlock>
            <h5 class="status-ko">
                Operazione non trovata o non ammessa
            </h5>
        </ng-template>
    </app-basic-card>
</div>
